<template>
    <div class="new-chat">

        <v-side-swipe-bar
            :show="$store.getters.barNewChat.value"
            sbName="newChat"
            :draggable="true"
            :outsideDisabed="true"
            :left-panel-open="quickRepliesOpen && !!activeChat"
            @hide="handleHide"
            @pin="handlePin"
        >
            <template slot="left-panel">
                <transition name="nc-qrp">
                    <div v-if="quickRepliesOpen && activeChat" class="nc-qrp-panel">
                        <div class="nc-qrp-panel__header">
                            <span class="nc-qrp-panel__title">Быстрые ответы</span>
                            <button
                                type="button"
                                class="nc-qrp-panel__close"
                                @click="setQuickRepliesOpen(false)"
                            >
                                <svg width="12" height="12" aria-hidden="true">
                                    <use href="#icon-close"></use>
                                </svg>
                            </button>
                        </div>
                        <new-chat-quick-replies-overlay @select="handleQuickReplySelect" />
                    </div>
                </transition>
            </template>

            <div class="qpay__header" slot="header" style="flex: 1;">
                <button
                    v-if="activeChat || activeTab === 'history'"
                    class="button button__no_min-width button_type_icon"
                    @click="handleBack"
                >
                    <svg width="16" height="16">
                        <use href="#icon-angle-left-crumbs"></use>
                    </svg>
                </button>
              <div style="margin-left: 8px; flex: 1; display: flex; gap: 10px">
                <p >{{ activeChat ? 'Чат' : activeTab === 'history' ? 'История' : 'Чат' }}</p>
                <button
                    v-if="!activeChat && activeTab !== 'history'"
                    class="button button__no_min-width button_type_icon nc-sound-btn"
                    :class="{ 'nc-sound-btn--active': soundEnabled }"
                    :title="soundEnabled ? 'Выключить звук' : 'Включить звук'"
                    @click="toggleSound"
                >
                  <svg v-if="soundEnabled" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M9.5 3a.5.5 0 0 0-.83-.37L4.5 6.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h2.5l4.17 3.87A.5.5 0 0 0 9.5 17V3z" fill="currentColor"/>
                    <path d="M12.5 7a3.5 3.5 0 0 1 0 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/>
                    <path d="M14.5 4.5a7 7 0 0 1 0 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                    <path d="M9.5 3a.5.5 0 0 0-.83-.37L4.5 6.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h2.5l4.17 3.87A.5.5 0 0 0 9.5 17V3z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                    <line x1="12.5" y1="7.5" x2="17.5" y2="12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    <line x1="17.5" y1="7.5" x2="12.5" y2="12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>

                  <button
                      v-if="!activeChat && activeTab !== 'history'"
                      class="button button__no_min-width button_type_icon nc-history-btn"
                      style="margin-left: auto; margin-right: 8px;"
                      title="История"
                      @click="handleOpenHistory"
                  >
                      <svg width="24" height="24" viewBox="0 0 20 20" style="color: #3A4146;" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="5" y="2" width="11" height="14" rx="1.5" fill="none"/>
                          <rect x="3" y="4" width="11" height="14" rx="1.5" fill="none"/>
                          <rect x="1" y="6" width="12" height="13" rx="1.5" fill="white"/>
                          <line x1="4" y1="10.5" x2="10" y2="10.5"/>
                          <line x1="4" y1="13.5" x2="10" y2="13.5"/>
                          <line x1="4" y1="16.5" x2="7.5" y2="16.5"/>
                      </svg>
                  </button>
            </div>

            <template slot="body">
                <div class="nc-body">
                    <new-chat-history-detail v-if="activeChat && isHistoryDetail" :chat="activeChat" />
                    <new-chat-detail v-else-if="activeChat" :chat="activeChat" @action="handleDetailAction" />
                    <new-chat-permission-banner v-else-if="needsPermission" />
                    <new-chat-history-contacts v-else-if="activeTab === 'history'" @select="item => handleSelectChat(item, true)" />
                    <new-chat-contacts v-else @select="item => handleSelectChat(item, false)" />

                    <transition name="nc-overlay-fade">
                        <div v-if="isDetailLoading" class="nc-body__overlay"> </div>
                    </transition>
                </div>
            </template>
        </v-side-swipe-bar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@api'
import vSideSwipeBar from '../../global/SideSwipeBar'
import NewChatContacts from '../../new-chat/contacts/NewChatContacts.vue'
import NewChatHistoryContacts from '../../new-chat/contacts/NewChatHistoryContacts.vue'
import NewChatDetail from '../../new-chat/detail/NewChatDetail.vue'
import NewChatHistoryDetail from '../../new-chat/detail/NewChatHistoryDetail.vue'
import NewChatPermissionBanner from '../../new-chat/shared/NewChatPermissionBanner.vue'
import NewChatQuickRepliesOverlay from '../../new-chat/messenger/quick-replies/NewChatQuickRepliesOverlay.vue'

export default {
    name: 'vNewChat',
    components: {
        vSideSwipeBar,
        NewChatContacts,
        NewChatHistoryContacts,
        NewChatDetail,
        NewChatHistoryDetail,
        NewChatPermissionBanner,
        NewChatQuickRepliesOverlay,
    },
    data() {
        return {
            isHistoryDetail: false,
        }
    },
    computed: {
        ...mapGetters('newChat', ['activeChat', 'isDetailLoading', 'fcmPermission', 'activeTab', 'soundEnabled', 'quickRepliesOpen']),
        needsPermission() {
            return this.fcmPermission !== null && this.fcmPermission !== 'granted'
        },
    },
    mounted() {
        api.newChat.getReference()
            .then(reference => {
                this.$store.dispatch('newChat/setReference', reference)
            })
            .catch(err => {
                console.error('[NewChat] reference error:', err)
            })
        this.refreshCounter()
    },
    beforeDestroy() {
        this.$store.dispatch('newChat/setTab', 'common')
        this.$store.dispatch('newChat/setSource', 'regular')
        this.$store.dispatch('newChat/setList', [])
        this.$store.dispatch('newChat/setActiveChat', null)
        this.$store.dispatch('newChat/setReference', null)
    },
    methods: {
        ...mapActions(['SET_BAR', 'SET_PIN']),
        ...mapActions('newChat', ['setSoundEnabled', 'setQuickRepliesOpen', 'applyQuickReply']),

        handleQuickReplySelect(phrase) {
            this.applyQuickReply(phrase)
        },
        toggleSound() {
            this.setSoundEnabled(!this.soundEnabled)
        },
        handleHide() {
            this.SET_BAR({ name: 'newChat', value: false })
        },
        handlePin(isPin) {
            this.SET_PIN({ name: 'newChat', val: isPin })
            this.$emit('pin', isPin)
        },
        handleBack() {
            if (this.activeChat) {
                this.$store.dispatch('newChat/setActiveChat', null)
                this.$store.dispatch('newChat/setQuickRepliesOpen', false)
                this.isHistoryDetail = false
            } else if (this.activeTab === 'history') {
                this.$store.dispatch('newChat/setTab', 'common')
            }
        },
        handleOpenHistory() {
            this.$store.dispatch('newChat/setTab', 'history')
        },
        handleDetailAction(action) {
            if (action === 'return' || action === 'end') {
                this.$store.dispatch('newChat/setActiveChat', null)
                return
            }
            // assign або department — перезавантажуємо деталь
            const id = this.activeChat.id
            this.$store.dispatch('newChat/setDetailLoading', true)
            api.newChat.getView(id)
                .then(chat => this.$store.dispatch('newChat/setActiveChat', chat))
                .catch(err => console.error('[NewChat] reload error:', err))
                .finally(() => this.$store.dispatch('newChat/setDetailLoading', false))
        },
        handleSelectChat(item, fromHistory = false) {
            this.isHistoryDetail = fromHistory
            if (fromHistory) {
                this.$store.dispatch('newChat/setActiveChat', item)
                return
            }
            this.$store.dispatch('newChat/setDetailLoading', true)
            api.newChat.getView(item.id)
                .then(chat => {
                    this.$store.dispatch('newChat/setActiveChat', chat)
                    this.refreshCounter()
                })
                .catch(err => {
                    console.error('[NewChat] view error:', err)
                })
                .finally(() => {
                    this.$store.dispatch('newChat/setDetailLoading', false)
                })
        },
        refreshCounter() {
            api.newChat.getTotalCounter()
                .then(response => {
                    this.$store.dispatch('newChat/setTotalUnread', (response.total_unread_my_chats_messages || 0) + (response.total_unread_new_chats_messages || 0))
                    this.$store.dispatch('newChat/setUnreadMyChats', response.total_unread_my_chats_messages || 0)
                })
                .catch(() => {})
        },
    }
}
</script>

<style lang="scss">
@import '../../../../../gulp-src/app/scss/_variables';

// ── Панель швидких відповідей (всередині sideBar__left-panel slot) ──

.nc-qrp-panel {
    width: 360px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: $global-white;
    border: 1px solid $global-light-gray;
    border-right: none;
    box-shadow: -4px 0 16px rgba(58, 65, 70, 0.08);
    overflow: hidden;

    &__header {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        padding: 10px 12px;
        border-bottom: 1px solid $global-light-gray;
        background: $global-white-f6;
    }

    &__title {
        flex: 1 1 auto;
        font-size: 14px;
        font-weight: 600;
        color: $global-black;
    }

    &__close {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        padding: 4px;
        cursor: pointer;
        color: $global-gray;
        border-radius: 50%;
        transition: background 0.15s ease, color 0.15s ease;

        &:hover {
            background: rgba(0, 0, 0, 0.06);
            color: $global-black;
        }
    }
}

// В drag-режимі — рамка збігається з рамкою sidebar + скруглення зліва
.sideBar_type_draggaable .nc-qrp-panel {
    border: 1px solid #CBCCCF;
    border-right: none;
    border-radius: 16px 0 0 16px;
    box-shadow: -4px 4px 16px rgba(58, 65, 70, 0.1);
}

// Slide-in зліва (панель виїжджає з-під sidebar)
.nc-qrp-enter-active,
.nc-qrp-leave-active {
    transition: transform 0.22s ease, opacity 0.22s ease;
}
.nc-qrp-enter,
.nc-qrp-leave-to {
    transform: translateX(20px);
    opacity: 0;
}

// ────────────────────────────────────────────────────────────────

.nc-body {
    position: relative;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;

    &__overlay {
        position: absolute;
        inset: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(2px);
        border-radius: 4px;
    }
}

.nc-overlay-fade-enter-active,
.nc-overlay-fade-leave-active {
    transition: opacity 0.18s ease;
}
.nc-overlay-fade-enter,
.nc-overlay-fade-leave-to {
    opacity: 0;
}

.new-chat-contacts {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 12px;
}

.new-chat-tabs {
    display: flex;
    flex: 0 0 auto;
    gap: 4px;

    &__btn {
        flex: 1 1 auto;
    }
}

.new-chat-list {
    flex: 1 1 auto;
    overflow-y: auto;
    margin-right: -10px;
    padding-right: 10px;

    &__empty {
        padding: 24px 0;
        text-align: center;
        font-size: 14px;
        color: $global-gray;
    }
}

// ---- Contact item ----

.nc-contact {
    display: flex;
    align-items: center;
    padding: 12px;
    border-top: 1px solid $global-light-gray;
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;

    &:last-child {
        border-bottom: 1px solid $global-light-gray;
    }

    &:hover {
        background-color: $global-white-f6;
    }

    &__img {
        flex: 0 0 48px;
        width: 48px;
        height: 48px;
        margin-right: 12px;

        img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    &__img-fallback {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: $global-light-gray;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $global-gray;
    }

    &__body {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    &__row {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 8px;
    }

    &__name {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: $global-black;
        flex: 1 1 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__date {
        flex: 0 0 auto;
        font-size: 12px;
        line-height: 16px;
        color: $global-gray;
        white-space: nowrap;
        margin-left: auto;
    }

    &__message {
        font-size: 14px;
        line-height: 20px;
        color: $global-gray;
        flex: 1 1 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__counter {
        flex: 0 0 auto;
        min-width: 20px;
        height: 20px;
        padding: 0 5px;
        background-color: $global-dark-3a;
        border-radius: 10px;
        color: $global-white;
        font-size: 11px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
    }

    &__alert {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 4px;
        font-size: 11px;
        line-height: 14px;
        color: #d97706;
        font-weight: 500;

        svg {
            flex: 0 0 auto;
            fill: currentColor;
        }
    }

    &__urgent-badge {
        flex: 0 0 auto;
        font-size: 10px;
        font-weight: 600;
        line-height: 1;
        color: #fff;
        background-color: #ef4444;
        border-radius: 4px;
        padding: 2px 5px;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    &_urgent {
        border-left: 3px solid #ef4444;
        padding-left: 9px;
    }
}

.nc-history-btn {
    color: $global-gray;
    border-radius: 50%;
    transition: color 0.15s ease, background 0.15s ease;

    &:hover {
        color: $global-dark-3a;
        background: rgba(0, 0, 0, 0.06);
    }
}

.nc-sound-btn {
    color: $global-gray;
    border-radius: 50%;
    transition: color 0.15s ease, background 0.15s ease;

    &:hover {
        color: $global-dark-3a;
        background: rgba(0, 0, 0, 0.06);
    }

    &--active {
        color: $global-purple;
    }
}
</style>
